/** Uniforme do clube e acessórios de posição (GDD, seções 4 e 8; item 2.4). */
import type { Position } from "./rules.js";

/** Cores do uniforme. O friso (gola, punhos, barras e cano da bota) usa a cor secundária. */
export interface Kit {
  primary: number;
  secondary: number;
  shorts: number;
  boots: number;
}

/** Malha de acessório que cada posição usa, para leitura de posição vista de cima. */
export const POSITION_ACCESSORY: Readonly<Record<Position, string>> = {
  artilheiro: "Bracadeira",
  goleiro: "Capacete",
  batedor: "Taco",
  cacador: "Capa",
};
export const ACCESSORY_MESHES = Object.values(POSITION_ACCESSORY);

/** O capacete do goleiro cobre o cabelo; com ele, as malhas de cabelo ficam escondidas. */
export const HELMET_HIDES_HAIR = true;

/** Cores fixas dos materiais dos acessórios (o resto vem do Kit). */
export const ACCESSORY_COLORS = {
  visor: 0x1f2a3a,
  wood: 0x7a4f2a,
  goggleStrap: 0x553820,
  goggleLens: 0xf2a838,
} as const;

/** Uniformes de exemplo, de clubes fictícios, usados nas folhas de referência e nos testes. */
export const EXAMPLE_KITS = {
  "corujas-campinas": { primary: 0x1f8a8a, secondary: 0xf2a541, shorts: 0x18323a, boots: 0x2a2320 },
  "lobos-guaiba": { primary: 0xc23b3b, secondary: 0xf4e3c1, shorts: 0x2b2b33, boots: 0x1e1e22 },
} as const satisfies Record<string, Kit>;

/** Contraste mínimo entre camisa e calção, para o uniforme não virar um bloco só de cima. */
export function kitContrast(kit: Kit): number {
  const lum = (hex: number) => {
    const c = [(hex >> 16) & 255, (hex >> 8) & 255, hex & 255].map((v) => {
      const s = v / 255;
      return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
    }) as [number, number, number];
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  };
  const a = lum(kit.primary);
  const b = lum(kit.shorts);
  return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
}
